import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Kinematic',
    description: 'Thirteen original casino games served from your own game server on Cloudflare, with every bet checkable in the browser.',
    url: getOrigin()
}
